module.exports = __webpack_public_path__ + "img/409.8455483d.jpg";